import React from 'react';
import { isToday, isWithinInterval, parseISO } from 'date-fns';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import VisitorsList from './VisitorsList';

const CurrentVisitors: React.FC = () => {
  // Filter function for visitors currently inside (scanned but not exited)
  const filterCurrentVisitors = (invite: any) => {
    // Must be scanned and not revoked
    if (!invite.scanned || invite.revoked) return false;
    
    // Check if the invite is valid for today
    if (!invite.isMultiDay && invite.visitDateTime) {
      const visitDate = parseISO(invite.visitDateTime);
      return isToday(visitDate);
    }
    
    if (invite.isMultiDay && invite.startDate && invite.endDate) {
      const startDate = parseISO(invite.startDate);
      const endDate = parseISO(invite.endDate);
      const now = new Date();
      
      return isWithinInterval(now, {
        start: new Date(startDate.setHours(0, 0, 0, 0)),
        end: new Date(endDate.setHours(23, 59, 59, 999)),
      });
    }
    
    return false;
  };

  return (
    <VisitorsList
      title="Visitors Currently Inside"
      icon={<PeopleAltIcon sx={{ color: '#345678' }} />}
      filterFunction={filterCurrentVisitors}
      emptyMessage="No visitors currently inside the estate."
      showBadge={true}
    />
  );
};

export default CurrentVisitors;